<template>
  <div>
    <b-overlay
      :show="loading"
      :opacity="0"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <b-row
        v-if="!users || users.length < 1"
        class="pt-2"
      >
        <discover-no-user>
          <h3 class="color-black">
            {{ $t('Sorry, no one has liked you yet') }}
          </h3>
        </discover-no-user>
      </b-row>
      <b-row class="pt-2">
        <user-card
          v-for="(user, i) in mergeFavoriteUsers"
          :key="user.id"
          :user="user"
          :order="i"
          :call-source="`liked_list`"
          @setLoading="setLoading($event)"
        />
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay, BRow } from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
// eslint-disable-next-line import/extensions
import UserCard from '@/components/UserCard'
// eslint-disable-next-line import/extensions
import DiscoverNoUser from '@/components/DiscoverNoUser'
import { throwDefaultError } from '@/helpers/helpers'

export default {
  name: 'InteractionReverseFavoriteUsers',
  components: {
    BRow,
    BOverlay,

    DiscoverNoUser,
    UserCard,
  },
  props: {
    activeTabIndex: {
      type: Number,
      default: 1,
    },
    favoriteUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      scrollOffsetForLoadMore: 100,
      users: [],
      usersLimit: 100,
      usersOffset: 0,
      usersAllLoaded: false,
    }
  },
  computed: {
    mergeFavoriteUsers() {
      return this.users.map(u => {
        u['isFavorite'] = false
        if (this.favoriteUsers.find(_u => _u.id === u.id)) {
          u['isFavorite'] = true
        }
        return u
      })
    },
    storeUsers() {
      return this.$store.getters['users/users']
    },
  },
  watch: {
    storeUsers: {
      handler(value) {
        this.users.forEach((user => {
          const storeUser = value.find(u => u.uuid === user.id)
          if (storeUser) {
            // eslint-disable-next-line no-param-reassign
            if (storeUser.status === 'USER_ONLINE') {
              // eslint-disable-next-line no-param-reassign
              user.profile.onlineStatus = 'online'
            } else if (storeUser.status === 'USER_OFFLINE') {
              // eslint-disable-next-line no-param-reassign
              user.profile.onlineStatus = 'offline'
            } else if (storeUser.status === 'USER_BUSY') {
              // eslint-disable-next-line no-param-reassign
              user.profile.busyInCall = true
            } else if (storeUser.status === 'USER_AVAILABLE') {
              // eslint-disable-next-line no-param-reassign
              user.profile.busyInCall = false
            }
            setTimeout(() => {
              this.$forceUpdate()
            }, 333)
          }
        }))
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getUsers()

    // Scroll'u dinle
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getUsers(clear = true) {
      this.loading = true
      useJwt.getReverseFavorites(this.usersOffset, this.usersLimit)
        .then(response => {
          if (clear) {
            this.users = response.data.body.users
            this.usersOffset = response.data.body.users.length
          } else {
            this.users.push(...response.data.body.users)
          }

          // Offset ayarla
          this.usersOffset = response.data.body.offset + response.data.body.limit

          if (this.usersOffset >= response.data.body.totalCount) {
            this.usersAllLoaded = true
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    handleScroll() {
      if (this.activeTabIndex === 2) {
        if ((window.innerHeight + window.scrollY + this.scrollOffsetForLoadMore) >= document.body.scrollHeight
            && !this.usersAllLoaded) {
          this.loadMore()
        }
      }
    },
    loadMore() {
      if (!this.loading) {
        this.getUsers(false)
      }
    },
    setLoading($event) {
      this.loading = $event
    },
  },
}
</script>

<style lang="scss">
/* Set the theme color of the component */
$themeColor: #F9447A;

/* import theme style */
@import '~vue-slider-component/lib/theme/default.scss';
</style>
